import { gql } from "@apollo/client";

const createPrivateNoteMutation = gql`
  mutation createPrivateNoteMutation($profileId: Int!, $notes: JSONString!) {
    createPrivateNote(profileId: $profileId, notes: $notes) {
      privateNote {
        id
        pk
        notes
        created
        creator {
          id
          name
          avatar
        }
      }
    }
  }
`;

export default createPrivateNoteMutation;
